import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment'; 
import withStyles from '@mui/styles/withStyles';
import { Grid, Paper, Tooltip, Typography} from '@mui/material';
import { NumericFormat } from 'react-number-format';
import HelpOutline from '@mui/icons-material/HelpOutline';

const abEnvironment = new AbEnvironment();
const BalanceTilesQuery = graphql`
query BalanceTilesQuery($accountId: UUID!) {
  getaccountledgersummary(accountId: $accountId, balancedate: null) {
    assetBalance
    assetAndArBalance
    assetArAuthBalance
    equityBalance
    maxPayoutBalance
    liabilityBalance
    authBalance
  }
}
`;

const styleSheet = theme => ({
  dbTile: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 212
  },
  dbTile2: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 184
  }
});

  
class BalanceTiles extends Component {
    
  render() {
    const classes = this.props.classes;

    let theTileClass = classes.dbTile;
    if (this.props.narrow === true) {
      theTileClass = classes.dbTile2;
    }

    return (
      <QueryRenderer
        environment={abEnvironment.getEnvironment()}
        query={BalanceTilesQuery}
        variables={{accountId: this.props.accountId}}
        render={({error, props})=> {

          if (error) {
            return <div>{error.message}</div>
          } else if (props) {

            let balanceTitle = "Balance";
            let balanceTt = "When your customer adds funds to their account, they'll have a positive balance in AppBind.";
            let availableBalanceTitle = "Available balance";
            let availableBalanceTt = "Your customer's balance may include funds that haven't settled yet, so the available balance indicates what is currently available to pay for subscriptions.";

            let equityBalance = props.getaccountledgersummary.equityBalance;
            if (equityBalance < 0) {
              equityBalance = 0;
            }

            let availableBalance = props.getaccountledgersummary.assetArAuthBalance;
  
            return (
              <Grid container spacing={3} justifyContent="flex-start">
                <Grid item>
                  <Paper className={theTileClass}>
                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                      <Grid item>
                        <Typography variant="h6">
                          <NumericFormat
                            value={equityBalance}
                            valueIsNumericString
                            prefix={'$'} 
                            displayType="text"
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator/>
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                          <Grid>
                            <Typography variant="body2" style={{marginTop: 2}}>{balanceTitle}</Typography>
                          </Grid>
                          <Grid item>
                            <Tooltip placement='bottom' title={balanceTt}>
                              <HelpOutline fontSize="small" style={{verticalAlign: "-9%", marginLeft: '4px'}}/>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>

                <Grid item>
                  <Paper className={theTileClass}>
                    <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                      <Grid item>
                        <Typography variant="h6">
                          <NumericFormat
                            value={availableBalance}
                            valueIsNumericString
                            prefix={'$'} 
                            displayType="text"
                            decimalScale={2}
                            fixedDecimalScale
                            thousandSeparator/>
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
                          <Grid>
                            <Typography variant="body2" style={{marginTop: 2}}>{availableBalanceTitle}</Typography>
                          </Grid>
                          <Grid item>
                            <Tooltip placement='bottom' title={availableBalanceTt}>
                              <HelpOutline fontSize="small" style={{verticalAlign: "-9%", marginLeft: '4px'}}/>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            );
          }  
        }}
      />
    );
  }
}

export default withStyles(styleSheet)(BalanceTiles);